/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  const target = event.target; 
  
  console.log(event);
  if (event.target.dataset.toggleTarget) {
 
    slideToggle(event);
  }
  if (event.target.dataset.tabTarget) {
    
    tabToggle(event);
  }
  if (event.target.dataset.modalTarget) { 
    modalPop(event);
  }
  if(event.target.hasAttribute('data-toggle-reset')) {
   // console.log('reset toggles');
    const toggles = document.querySelectorAll('[data-toggle-target]');
    const targets = document.querySelectorAll('[data-toggle-content]'); 
    toggles.forEach((toggle) => { 
        toggle.classList.remove('active'); 
    });
    targets.forEach((toggle) => { 
        toggle.classList.remove('active'); 

        setTimeout(function () {
          toggle.style.height = '0px';
        }, 500);
     
    }); 
  }

  if(event.target.hasAttribute('data-close-outside')) {
    const parent = event.target.closest('[data-toggle-content]');
    toggleTargetName = parent.dataset.toggleContent;
    parent.classList.remove('active');
    document.querySelector(`[data-toggle-target="${toggleTargetName}"]`).classList.remove('active');
  }  
});


document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const closeItems = document.querySelectorAll('[data-close-outside]');
    closeItems.forEach((item) => {
      parent = item.closest('[data-toggle-content]');
      toggleTargetName = parent.dataset.toggleContent; 
      parent.classList.remove('active');
      document.querySelector(`[data-toggle-target="${toggleTargetName}"]`).classList.remove('active');
    });
  
      //console.log('Escape key pressed');
  }
});


/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  event.preventDefault();
  console.log('slide down toggle');
  const toggles = document.querySelectorAll('[data-toggle-target]');
  const targets = document.querySelectorAll('[data-toggle-content]');
  const target = event.target.dataset.toggleTarget;

  const toggleContainer = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );
  //console.log(toggleContainer, 'TOGGLE CONTAINER');


  // FOR RESETTING ALL ITEMS

  if (event.target.hasAttribute('data-reset')) {
    toggles.forEach((toggle) => {
      if (
        (toggle.dataset.toggleTarget == target) &
        toggle.classList.contains('active')
      ) {
        toggle.classList.remove('active');
      } else {
        toggle.classList.add('active');
      }
      if (toggle.dataset.toggleTarget != target) {
        toggle.classList.remove('active');
      }
    });
    targets.forEach((toggle) => {
      if (toggle.dataset.toggleContent != target) {
        toggle.classList.remove('active');
      }
    });
  }

  toggleContainer.forEach((group) => {
    if (!group.classList.contains('active')) {
      toggles.forEach((toggle) => {
        if (toggle.dataset.toggleTarget == target) {
          toggle.classList.add('active');
        }
      });

      group.classList.add('active');
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';

      setTimeout(function () {
        group.style.height = height;
      }, 0);

      group.addEventListener(
        'transitionend',
        function () {
          console.log('transition end');
          group.style.height = 'auto';
        },
        {
          once: true,
        }
      );
    } else {
      toggles.forEach((toggle) => {
       // console.log(toggle.dataset.toggleTarget, 'DATA TARGET');
        if (toggle.dataset.toggleTarget == target) {
          toggle.classList.remove('active');
        }
      });

      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
     // console.log(height, 'height');
      group.style.height = height;

      setTimeout(function () {
        group.style.height = height;
        group.classList.remove('active');
        group.style.height = '0px';
        //console.log('remove active', group);
      }, 0);
      group.addEventListener(
        'transitionend',
        function () {
          //console.log('close toggle transition end');
          group.style.height = '0px';
        },
        {
          once: true,
        }
      );
    }
  });


}

/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();
  const target = event.target.dataset.tabTarget;
  const tabGroup = event.target.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
  tabGroups.forEach((group) => {
    group.classList.remove('active');
  });
  event.target.classList.add('active');
  document
    .querySelectorAll(
      `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
    )
    .forEach((group) => {
      group.classList.add('active');
    });
}

// MODAL TOGGLING
function modalPop(event) {
  console.log(event);
  event.preventDefault();
  const target = event.target.dataset.modalTarget;
  const modalContent = document.querySelector(
    `[data-modal-content="${target}"]`
  );
  const closeModal = modalContent.querySelector('[data-close]');
  const modalSlider = modalContent.querySelector('.bd-slider');
  console.log('open modal');
  modalContent.classList.add('active');
  document.querySelector('body').classList.add('overflow-hidden');
  closeModal.onclick = function () {
    //  console.log('close modal');
    modalContent.classList.remove('active');
    document.querySelector('body').classList.remove('overflow-hidden');
  };
  window.onclick = function (event) {
    // console.log(event);
    if (event.target == modalContent) {
      // console.log('close modal');

      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  };
  window.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  });

  if (modalSlider) {
    const slider = new slick(modalSlider);
    // console.log('resize slider');
    slider.resize();
  }
}
